var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.bannerImage)?_c('div',{staticClass:"banner",style:({backgroundImage: 'url('+ _vm.bannerImage +')',height:_vm.bannerHeight})}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }